import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/data/articles';

export default function ArticlesSection() {
  const { t } = useTranslation();

  return (
    <section id="articles" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="text-center">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">{t('home.articles.title')}</h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          {t('home.articles.subtitle')}
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {articles.map((a) => (
          <Link
            key={a.slug}
            to={`/article/${a.slug}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="h-40 w-full overflow-hidden">
              <img
                src={a.image}
                alt={a.title}
                title={a.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-5">
              <span className="inline-flex w-fit items-center rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-semibold text-secondary-900">
                {a.category}
              </span>
              <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-900 group-hover:text-primary-700">
                {a.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{a.excerpt}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs text-foreground-500">{a.readTime}</span>
                <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary-600">
                  {t('home.articles.readMore')}
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}